import { useState, type ReactNode } from 'react'
import { SaveFABContext } from './SaveFABContext'

export function SaveFABProvider({ children }: { children: ReactNode }) {
  const [hasSaveFAB, setHasSaveFAB] = useState(false)
  const [needsFloatingPadding, setNeedsFloatingPadding] = useState(false)
  return (
    <SaveFABContext.Provider
      value={{
        hasSaveFAB,
        setHasSaveFAB,
        needsFloatingPadding,
        setNeedsFloatingPadding,
      }}
    >
      {children}
    </SaveFABContext.Provider>
  )
}
